import { INVESTOR_TYPES } from "@/lib/investorTypes";
import { Badge } from "@/components/ui/badge";

/**
 * Compact multi-select chip picker for choosing which investor types a field
 * or document applies to. Empty selection = applies to ALL investor types.
 */
export default function InvestorTypeSelector({ value = [], onChange, disabled = false, testId }) {
  // Normalize: strip legacy keys and dedupe.
  const selected = Array.isArray(value) ? value.filter(Boolean) : [];

  const toggle = (t) => {
    if (disabled) return;
    const next = selected.includes(t) ? selected.filter((x) => x !== t) : [...selected, t];
    onChange(next);
  };

  const isAll = selected.length === 0;

  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid={testId}>
      <button
        type="button"
        disabled={disabled}
        onClick={() => onChange([])}
        className={`text-[10px] uppercase tracking-wider px-2 py-1 rounded-md border transition-all ${isAll ? "bg-primary/15 border-primary/40 text-primary" : "bg-secondary/40 border-border/50 text-muted-foreground hover:text-foreground"}`}
        data-testid={testId ? `${testId}-all` : undefined}
      >
        All Types
      </button>
      {INVESTOR_TYPES.map((t) => {
        const active = selected.includes(t);
        return (
          <button
            key={t}
            type="button"
            disabled={disabled}
            onClick={() => toggle(t)}
            className={`text-[10px] uppercase tracking-wider px-2 py-1 rounded-md border transition-all ${active ? "bg-emerald-500/15 border-emerald-500/40 text-emerald-300" : "bg-secondary/40 border-border/50 text-muted-foreground hover:text-foreground"}`}
            data-testid={testId ? `${testId}-${t.toLowerCase().replace(/[^a-z0-9]+/g, "-")}` : undefined}
          >
            {t}
          </button>
        );
      })}
      {!isAll && (
        <Badge variant="outline" className="text-[10px] ml-1 border-border/50 text-muted-foreground">
          {selected.length} selected
        </Badge>
      )}
    </div>
  );
}
